import { render, staticRenderFns } from "./DiscoverLivePreviews.vue?vue&type=template&id=5fedb437&scoped=true&"
import script from "./DiscoverLivePreviews.vue?vue&type=script&lang=ts&"
export * from "./DiscoverLivePreviews.vue?vue&type=script&lang=ts&"
import style0 from "./DiscoverLivePreviews.vue?vue&type=style&index=0&id=5fedb437&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fedb437",
  null
  
)

export default component.exports